<template>
  <div>
    <div class="main-scn">
      <img :src="$getImage(`onesti-logo/onesti-logo-branco-${currentLocale}.svg`)" class="main-scn__logo" :alt="`${$t('alt.logo')} Onesti`">
      <p class="main-scn__slogan">
        {{ $t('mobileHome.mainSection') }}
      </p>
      <div class="language-menu" :class="{'language-menu--opened' : isLanguageMenuOpened}">
        <div class="language-btn" @click="toggleLanguageMenu">
          <font-awesome-icon icon="globe" />
        </div>
        <div class="language-menu__options" :class="{'language-menu__options--opened' : isLanguageMenuOpened}">
          <div class="language-menu__item" @click="changeLanguage('pt')">
            Português
          </div>
          <div class="language-menu__item" @click="changeLanguage('es')">
            Español
          </div>
          <div class="language-menu__item" @click="changeLanguage('en')">
            English
          </div>
          <div class="language-menu__item" @click="changeLanguage('cn')">
            中国
          </div>
        </div>
      </div>
    </div>
    <scn>
      <h2 class="presentation-title">
        {{ $t('presentation.title') }}
      </h2>
      <p class="presentation-paragraph">
        {{ $t('presentation.text') }}
      </p>
    </scn>
    <mobile-scn color="black" border-color="pink">
      <mobile-section-header
        slot="title"
        type="creativity"
        :title="$t('mobileHome.creativity.title')"
      />
      <slot>
        <p v-for="paragraph in $t('mobileHome.creativity.paragraphs')" class="mb-2">
          {{ paragraph }}
        </p>
      </slot>
      <p slot="footer">
        {{ $t('mobileHome.creativity.footer') }}
      </p>
    </mobile-scn>
    <mobile-scn color="pink" border-color="white">
      <mobile-section-header
        slot="title"
        type="solutions"
        :title="$t('mobileHome.solutions.title')"
      />
      <slot>
        <p v-for="paragraph in $t('mobileHome.solutions.paragraphs')" class="mb-2">
          {{ paragraph }}
        </p>
        <ul class="pl-1 ml-1 mb-1">
          <li v-for="item in $t('mobileHome.solutions.list')">
            {{ item }}
          </li>
        </ul>
      </slot>
      <div slot="footer">
        <p>
          {{ $t('mobileHome.solutions.footer.hashTag') }}
        </p>
        <div class="slogan my-2">
          <p>
            {{ $t('mobileHome.solutions.footer.slogan.firstPiece') }}
          </p>
          <p class="slogan__main-word">
            {{ $t('mobileHome.solutions.footer.slogan.mainWord') }}
          </p>
          <p>
            {{ $t('mobileHome.solutions.footer.slogan.lastPiece') }}
          </p>
        </div>
        <img src="@/assets/images/onesti-logo/a-symbol-white.svg" class="w-12" alt="null" aria-hidden="true">
        <img src="@/assets/images/sections/section-divider.svg" class="section-divider" alt="null" aria-hidden="true">
      </div>
    </mobile-scn>
    <mobile-scn color="dark" border-color="pink">
      <mobile-section-header
        slot="title"
        type="bio"
        :title="$t('mobileHome.bio.title')"
      />
      <img
        slot="divider"
        :src="$getImage(`sections/section-divider-black.svg`)"
        class="section-divider section-divider--black"
      >
      <slot>
        <img v-if="currentLocale === 'pt'"
             :src="$getImage(`sections/inovacao-logo-${currentLocale}.svg`)"
             class="innovation-logo"
             aria-hidden="true"
             alt="null"
        >
        <p v-for="paragraph in $t('mobileHome.bio.paragraphs')" class="mb-2">
          {{ paragraph }}
        </p>
      </slot>
      <p slot="footer">
        {{ $t('mobileHome.bio.footer') }}
      </p>
    </mobile-scn>
    <footer class="px-3 py-3">
      <div class="relative text-center mb-4">
        <span class="say-hi">
          {{ $t('mobileHome.footer.sayHi') }}
        </span>
        <img :src="$getImage(`onesti-logo/onesti-logo-${currentLocale}.svg`)" class="w-40" :alt="`${$t('alt.logo')} Onesti`">
      </div>
      <div class="text-center mb-3">
        <button class="btn" @click="goToFullVersionPage">
          {{ $t('mobileHome.footer.buttonLabel') }}
        </button>
      </div>
      <div class="contact">
        <p class="inline-flex">
          <span>
            {{ $t('email.name') }}@
          </span>
          <span class="text-pink">
            {{ $t('email.highlightedWord') }}
          </span>
          <span>
            {{ $t('email.domain') }}
          </span>
        </p>
        <div class="address">
          <p>
            Avenida Paulista, nº 91, 1º andar
          </p>
          <p>
            Bela Vista, São Paulo, SP, {{ currentLocale === 'pt' ? 'BRASIL' : 'BRAZIL' }} 01310-916
          </p>
        </div>
        <contact-number color="pink" />
        <p>
          @onesti.adv
        </p>
      </div>
      <social-media-icons centered class="mb-2" />
      <p class="hash-tag mb-2">
        {{ $t('mobileHome.footer.hashTag') }}
        <img :src="$getImage('icone-coracao-rosa.svg')" class="hash-tag__icon" alt="ícone de coração" aria-hidden="true">
      </p>
      <div class="disclaimer">
        <p v-for="paragraph in $t('disclaimer')">
          {{ paragraph }}
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import MobileSectionHeader from '@/components/mobile-section-header'
import MobileScn from '@/components/mobile-scn'
import SocialMediaIcons from '@/components/social-media-icons'
import ContactNumber from '@/components/contact-number'

export default {
  name: 'MobileHome',
  components: { ContactNumber, MobileSectionHeader, MobileScn, SocialMediaIcons },
  data () {
    return {
      isLanguageMenuOpened: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    changeLanguage (lang) {
      this.$router.push({
        name: 'home-lang',
        params: {
          lang
        }
      })
      this.isLanguageMenuOpened = false
    },
    toggleLanguageMenu () {
      this.isLanguageMenuOpened = !this.isLanguageMenuOpened
    },
    goToFullVersionPage () {
      this.$store.dispatch('changeMobileHomeVisibility', false)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.main-scn
  @apply relative flex flex-col items-center justify-center bg-pink w-full h-80
  background-size: cover
  background-image: url('~@/assets/images/vista-rua-com-predios@small.jpg')
  &__logo
    @apply w-64 mt-3
  &__slogan
    @apply text-white text-lg font-thin mt-2
    letter-spacing: 1px

.language-menu
  @apply absolute pin-t pin-r flex flex-col items-end text-white w-10 h-10
  background-color: rgba(0, 0, 0, 0.7)
  transition: all .2s
  &__options
    @apply flex flex-col text-right overflow-hidden pointer-events-none
    height: 0
  &__item
    @apply p-1
  &--opened
    @apply w-24 h-48
    .language-menu
      &__options
        @apply pointer-events-auto h-auto

.language-btn
  @apply inline-flex items-center justify-center text-2xl p-1 w-10 h-10

.presentation-title
  @apply text-center text-lg text-grey uppercase font-bold mb-3

.presentation-paragraph
  @apply text-grey text-center
  letter-spacing: 1px

.section-divider
  @apply absolute pin-l z-10 w-full
  top: 98%
  &--black
    @apply z-0
    top: 161px
    @screen sm-l
      top: 139px
    @screen md
      top: 135px
    @screen lg
      top: 117px

.innovation-logo
  @apply block w-32 mx-auto mb-3

.slogan
  @apply uppercase text-xl text-black font-thin
  &__main-word
    @apply text-white font-condensed
    font-size: 2.78rem

.say-hi
  @apply absolute half-l -translate-x-50 font-condensed text-lg text-grey
  bottom: -20px

.contact
  @apply text-center
  & > *
    @apply mb-2

.btn
  @apply text-white text-lg bg-pink rounded shadow-md cursor-pointer px-2 py-1

.hash-tag
  @apply flex items-center justify-center
  &__icon
    @apply w-4 ml-1

.disclaimer
  @apply text-grey text-xs
</style>
